"use client";

import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui/material";
import Head from "next/head";
import React from "react";
import { ArgsEditor } from "#/features/argsEditor/ui/ArgsEditor";
import { CodePanel } from "#/features/codeRunner/ui/CodePanel";
import { useProjectPanelData } from "#/features/project/hooks/useProjectPanelData";
import { ProjectInfo } from "#/features/project/ui/ProjectInfo";
import { TestCaseSelectBar } from "#/features/project/ui/TestCaseSelectBar";
import { CollapsiblePanel } from "./CollapsiblePanel";
type MobileCodeViewProps = {
  onRunComplete: () => void;
};
export const MobileCodeView: React.FC<MobileCodeViewProps> = t0 => {
  const $ = _c(24);
  const {
    onRunComplete
  } = t0;
  const {
    selectedProject,
    selectedCase
  } = useProjectPanelData();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      minWidth: 0,
      overflow: "hidden"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== selectedProject.data) {
    t2 = <Box sx={t1}><ProjectInfo project={selectedProject.data} /></Box>;
    $[1] = selectedProject.data;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const argsHeader = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "flex",
      flexDirection: "column",
      height: "100%",
      overflow: "hidden"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = selectedProject.data ? `${selectedProject.data.title} - dStruct Playground` : "dStruct Playground";
  let t5;
  if ($[4] !== t4) {
    t5 = <Head><title>{t4}</title></Head>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      p: 1.5,
      maxHeight: "35vh",
      overflowY: "auto"
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== selectedProject) {
    t7 = <TestCaseSelectBar selectedProject={selectedProject} />;
    $[7] = selectedProject;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== selectedCase) {
    t8 = <ArgsEditor selectedCase={selectedCase} />;
    $[9] = selectedCase;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t7 || $[12] !== t8) {
    t9 = <Box sx={t6}>{t7}{t8}</Box>;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== argsHeader || $[15] !== t9) {
    t10 = <CollapsiblePanel header={argsHeader}>{t9}</CollapsiblePanel>;
    $[14] = argsHeader;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      flex: 1,
      minHeight: 0,
      overflow: "hidden"
    };
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== onRunComplete) {
    t12 = <Box sx={t11}><CodePanel onRunComplete={onRunComplete} /></Box>;
    $[18] = onRunComplete;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t10 || $[21] !== t12 || $[22] !== t5) {
    t13 = <Box sx={t3}>{t5}{t10}{t12}</Box>;
    $[20] = t10;
    $[21] = t12;
    $[22] = t5;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  return t13;
};